import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
} from '@mui/material';
import { useAddTeam, useEditTeam } from '../../hooks/useTeam';
import { useDivision } from '../../hooks/useDivision';

const TeamForm = ({ open, onClose, formData, onInputChange, editData }) => {
    const { data: divisions } = useDivision();
    const addTeam = useAddTeam();
    const editTeam = useEditTeam();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (editData) {
                await editTeam.mutateAsync({ 
                    id: editData.id,
                    data: {
                        ...formData,
                        updated_at: new Date().toISOString()
                    }
                });
            } else {
                await addTeam.mutateAsync({
                    ...formData,
                    created_at: new Date().toISOString(),
                });
            }
            onClose();
        } catch (error) {
            console.error('Error handling team:', error);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle className="bg-blueColor text-white py-4">
                <i className="fas fa-plus text-xl mx-2"></i>
                <span className="text-xl font-semibold">{editData ? 'Edit Team' : 'Add New Team'}</span>
            </DialogTitle>
            <form onSubmit={handleSubmit}>
                <DialogContent className="mt-4">
                    <div className="grid grid-cols-1 gap-4 p-4">
                        <div>
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Name
                            </label>
                            <input
                                name="name"
                                value={formData.name}
                                onChange={onInputChange}
                                type="text"
                                required
                                className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
                            />
                        </div>

                        <div>
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Description
                            </label>
                            <textarea
                                name="description"
                                value={formData.description}
                                onChange={onInputChange}
                                className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
                                rows="4"
                            />
                        </div>

                        <div>
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Division
                            </label>
                            <select
                                name="division_id"
                                value={formData.division_id}
                                onChange={onInputChange}
                                required
                                className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
                            >
                                <option value="">Select Division</option>
                                {divisions?.map((division) => (
                                    <option key={division.id} value={division.id}>
                                        {division.acronym} - {division.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="flex justify-end gap-4 mt-6 p-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-blueColor text-white rounded"
                        >
                            {editData ? 'Save Changes' : 'Add'}
                        </button>
                    </div>
                </DialogContent>
            </form>
        </Dialog>
    );
};

export default TeamForm; 